import React from 'react';
import { Facebook, Twitter, Instagram, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-navy-900 border-t border-silver-600/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div className="col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img
                src={`${process.env.PUBLIC_URL}/logo-icon.png`}
                alt="Global Digital Print"
                className="h-12 w-auto"
              />
              <img
                src={`${process.env.PUBLIC_URL}/logo-text.png`}
                alt="Global Digital Print"
                className="h-10 w-auto filter brightness-0 invert"
              />
            </div>
            <p className="text-silver-400 mb-4">
              Your trusted partner for premium digital printing and packaging solutions.
            </p>
            <div className="flex gap-4">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="bg-navy-700/50 p-2 rounded-lg border border-silver-600/30 hover:border-silver-400/50 transition-colors">
                <Facebook className="text-silver-300" size={20} />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="bg-navy-700/50 p-2 rounded-lg border border-silver-600/30 hover:border-silver-400/50 transition-colors">
                <Twitter className="text-silver-300" size={20} />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="bg-navy-700/50 p-2 rounded-lg border border-silver-600/30 hover:border-silver-400/50 transition-colors">
                <Instagram className="text-silver-300" size={20} />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="bg-navy-700/50 p-2 rounded-lg border border-silver-600/30 hover:border-silver-400/50 transition-colors">
                <Linkedin className="text-silver-300" size={20} />
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => document.getElementById('home').scrollIntoView({ behavior: 'smooth' })} className="text-silver-400 hover:text-silver-200 transition-colors">
                  Home
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })} className="text-silver-400 hover:text-silver-200 transition-colors">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('products').scrollIntoView({ behavior: 'smooth' })} className="text-silver-400 hover:text-silver-200 transition-colors">
                  Products
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById('testimonials').scrollIntoView({ behavior: 'smooth' })} className="text-silver-400 hover:text-silver-200 transition-colors">
                  Testimonials
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Services</h4>
            <ul className="space-y-2 text-silver-400">
              <li>Business Cards</li>
              <li>Banners & Posters</li>
              <li>Packaging</li>
              <li>Brochures</li>
              <li>Stationery</li>
              <li>Promotional Items</li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-silver-400">
                <Phone size={18} className="mt-1 flex-shrink-0" />
                <span>+91 98841 22553 / +91 93452 99622 / +91 63746 80867</span>
              </li>
              <li className="flex items-start gap-2 text-silver-400">
                <Mail size={18} className="mt-1 flex-shrink-0" />
                <span>globaldp12@gmail.com</span>
              </li>
              <li className="flex items-start gap-2 text-silver-400">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>No.92/111, Jani Jhan Khan Road, Royapettah, Chennai - 600 014.</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-silver-600/20 pt-8 text-center">
          <p className="text-silver-400">
            © {currentYear} Global Digital Print. All rights reserved. | Designed with excellence | Developed by{' '}
            <a
              href="https://kumkilabs.ai"
              target="_blank"
              rel="noreferrer"
              className="text-silver-300 hover:text-silver-100 transition-colors"
            >
              Kumkilabs.ai
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
